import { TypeVideo,  } from "../../components/replay/VideoItem";
import { EpisodeInfo, LastAwardInfo, SectorInfo, YoutubeVideo } from "../../services/models";
import { atom } from "recoil";

export const episodeInfoState = atom<EpisodeInfo>({
    key: 'episodeInfoState',
    default: new EpisodeInfo()
})

export const lastAwardInfoState = atom<LastAwardInfo[]>({
    key: 'lastAwardInfoState',
    default: []
})

export const sectorState = atom<SectorInfo[]>({
    key: 'sectorState',
    default: []
})

export const mainVideoState = atom<TypeVideo[]>({
    key: 'mainVideoState',
    default: []
})

export type YoutubeListType = {
    year: number,
    no: number,
    keys: string[]
}
export const replayVideoState = atom<YoutubeListType[]>({
    key: 'replayVideoState',
    default: [
        {
            year: 2025,
            no: 61,
            keys: [
                'PLBJ27tLUJj0zdy-Ju3k-a014Wh_TcVSSf',
                'PLBJ27tLUJj0yjX4p42HKn_bPjAPXnzET-',
                'PLBJ27tLUJj0y2dyNogaDCi6jh_jwD1DWx',
            ]
        },
        {
            year: 2024,
            no: 60,
            keys: [
                'PLBJ27tLUJj0zFXxTfZ-mo8KYPdoQOVMK1',
                'PLBJ27tLUJj0wLoP973NjL-dbGSJ6603Jn',
                'PLBJ27tLUJj0za1iB0ZyEKh8DBvuvk87ab',
            ]
        },
        {
            year: 2023,
            no: 59,
            keys: [
                'PLBJ27tLUJj0yid4Q1LtGw5WgKnIPokoDR',
                'PLBJ27tLUJj0xxTFRDZNBNMlxnPhCTBYsk',
                'PLBJ27tLUJj0zO-HGrxiE6ywEyItH_q81B',
            ]
        },
        {
            year: 2022,
            no: 58,
            keys: [
                'PLBJ27tLUJj0w2Okwf5fzonQEDPMbFGCbd',
                'PLBJ27tLUJj0yIoaZkD280maJrRMPOVu45',
            ]
        },
        {
            year: 2021,
            no: 57,
            keys: [
                'PLBJ27tLUJj0wQqAFeFi9NLqIMFMK_oKsK',
                'PLBJ27tLUJj0wL10WOBmDlOnJOC-5xt26d',
                'PLBJ27tLUJj0zoQNCIlgi08BKEfmXB5X7k',
            ]
        },
        {
            year: 2020,
            no: 56,
            keys: [
                'PLBJ27tLUJj0y-j8hJIiyAX8BcUkD4ZTvf',
                'PLBJ27tLUJj0zVRk6dsUtnEJUBhiuGuCNd',
                'PLBJ27tLUJj0weC6i9s4WoszwS9Yc3ncUN',
            ]
        },
        {
            year: 2019,
            no: 55,
            keys: [ 
                'PLBJ27tLUJj0yyD-nHc7TpQI_Rb23TJ3iR',
                'PLBJ27tLUJj0x5Md6um1bmwkNbNSAi1AA1',
                'PLBJ27tLUJj0xfKDmaucsMjjV39IjaSVlK'
            ]
        },
        {
            year: 2018,
            no: 54,
            keys: [
                'PLBJ27tLUJj0xVwSQ4FYR5vA_OIGgg9DdO',
            ]
        },
        {
            year: 2017,
            no: 53,
            keys: [
                'PLBJ27tLUJj0yLttltwKUgcLW6en32DJ4u',
            ]
        },
        {
            year: 2016,
            no: 52,
            keys: [
                'PLBJ27tLUJj0z4PoRnLzbS4JTDYD-Wm0hT',
            ]
        },
    ]
})

export const replayVideoListState = atom<YoutubeVideo[]>({
    key: 'replayVideoListState',
    default: []
})

export const homeReplayVideoListState = atom<YoutubeVideo[]>({
    key: 'homeReplayVideoListState',
    default: []
})

export const homeReplayVideoState = atom<string[]>({
    key: 'homeReplayVideoState',
    default: [
        'PLBJ27tLUJj0zdy-Ju3k-a014Wh_TcVSSf',
        'PLBJ27tLUJj0yjX4p42HKn_bPjAPXnzET-',
        'PLBJ27tLUJj0y2dyNogaDCi6jh_jwD1DWx',
    ]
})